import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import ProgressBarLoader from './loadingScreen'
import { Suspense } from 'react'
import { Loader } from '@react-three/drei'




const root = ReactDOM.createRoot(document.querySelector('#root'))




root.render(
  <>
  <ProgressBarLoader/>
    <Canvas
      shadows
      orthographic
      camera={{
        zoom: 80,
        near: 0.1,
        far: 2000,
        position: [10, 5, 7],
      }}
      
    >
      <Suspense fallback={null }>
      
      <Experience />
      </Suspense>
      
    </Canvas>
    
     </>
  );
  